var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("canvas", {
      ref: "avatarEditorCanvas",
      staticClass: "cursorPointer",
      attrs: {
        width: _vm.canvasWidth,
        height: _vm.canvasHeight,
        id: "avatarEditorCanvas",
      },
      on: {
        dragover: function ($event) {
          $event.preventDefault()
        },
        drop: _vm.onDrop,
        mousedown: _vm.onDragStart,
        touchstart: _vm.onDragStart,
        click: _vm.clicked,
      },
    }),
    _c("input", {
      ref: "input",
      staticStyle: { display: "none" },
      attrs: { type: "file", accept: _vm.accept },
      on: { change: _vm.fileSelected },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }